import type { AbschnittCElectionResultWithoutCommons } from "@/lib/abschnittc/AbschnittCElectionResult";

export class AbschnittCElectionEvaulationInterrupt extends Error {
	constructor(public resultWithoutCommons: AbschnittCElectionResultWithoutCommons) {
		super("InterruptedError");
	}

	static isInterruptedError(e: Error): e is AbschnittCElectionEvaulationInterrupt {
		return e.message === "InterruptedError";
	}
}
